import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';

export const StyledFloatingTicketPanelInstance = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCollapsed',
})(({ isCollapsed }) => ({
  alignSelf: 'end',
  // transition: 'left 0.4s ease, top 0.4s ease, right 0.4s ease, bottom 0.4s ease, width 0.4s ease, height 0.4s ease',
  iframe: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: isCollapsed ? '#4F4F4F' : '#DADCDE',
    boxShadow: '0px -10px 24px -4px rgba(16, 24, 40, 0.08), 0px -8px 8px -4px rgba(16, 24, 40, 0.03)',
  },

  '.loader': {
    width: '100%',
    height: '100%',
    transition: 'opacity 0.4s ease',
  },
}));

export const StyledFloatingTicketPanelInstanceBackground = styled(Box)(() => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1,
}));
